/**
 * 当缓存中的扩展数据没有自己需要的数据的时候，需要重新请求返回
 */
export const _extraDataOptions = {
  projectId: [ 'mangerUserId', 'assessUserId' ]
}

/**
 * 判断是否存在
 */
export const checkCacheExtraExist = (extraData, cacheValue) => {
  const nonExistKey = Object.keys(extraData).filter(key => {
    if (!cacheValue.extraData || cacheValue.extraData[key] !== extraData[key]) { return true }
    return false
  })
  return nonExistKey.length === 0
}